import React from 'react';

export const Home = () =>
    <section>
        <div className="container text-center">
            <h1>Custom page by Christina</h1>
        </div>
    </section>;



// WEBPACK FOOTER //
// ./src/components/Home/index.js